import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import store from "./store";
import history from "./history";
import Layouts from "./layouts";
import { THEME_CONFIG, CHAT_ENABLED } from "./configs/AppConfig";
import "./lang";
import viLocale from "moment/locale/vi";
import moment from "moment";
// import { generateToken, onMessageListener } from "auth/FirebaseAuth";
import { Avatar, notification } from "antd";
import { getMessaging, onMessage } from "firebase/messaging";
// import { getNoti } from "store/slices/common/erpNotificationSlice";
import { MailOutlined } from "@ant-design/icons";
import ChatLauncher from "ChatLauncher";
import { showOsNotification } from "utils/osNotification";

moment.updateLocale("vi", viLocale);

// Noti của chat: chỉ bắn ra OS notification, KHÔNG hiện popup antd trong app - vì bản thân
// chat đã có rail/badge chưa đọc riêng, thêm popup nữa là thông báo đúp.
// Danh sách giữ khớp với CHAT_OBJECT_TYPES trong public/firebase-messaging-sw.js.
const CHAT_OBJECT_TYPES = ["Chat", "ChatMessage", "Conversation", "ChatConversation"];

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

function App() {
  // Xin quyền thông báo ngay khi mở app (nếu chưa từng hỏi). Không chờ tới lần đăng nhập
  // sau, vì người đang đăng nhập sẵn sẽ không bao giờ được hỏi.
  useEffect(() => {
    if (typeof Notification !== "undefined" && Notification.permission === "default") {
      Notification.requestPermission().catch(() => {});
    }
  }, []);

  // Đăng ký listener 1 LẦN. Trước đây onMessage() gọi thẳng trong thân component nên
  // mỗi lần re-render lại đăng ký thêm 1 listener -> 1 noti hiện nhiều lần.
  useEffect(() => {
    const unsubscribe = onMessage(getMessaging(), (payload) => {
      const d = payload?.data || {};
      const title = payload?.notification?.title || d.title || "Thông báo";
      // Nội dung tin nhắn: BE mỗi chỗ đặt một tên khoá khác nhau nên dò lần lượt.
      const body =
        payload?.notification?.body || d.body || d.message || d.content || "";
      // Ảnh đại diện người gửi: NavNotification dùng senderAvatarUrl, FCM hay gửi imageUrl.
      const imageUrl =
        payload?.notification?.image ||
        d.imageUrl ||
        d.senderAvatarUrl ||
        d.avatarUrl ||
        d.avatar;

      // Tin nhắn chat -> noti NGOÀI trang (kiểu Zalo), không hiện popup trong app.
      if (CHAT_OBJECT_TYPES.includes(d.type)) {
        showOsNotification({
          title,
          body,
          icon: imageUrl,
          tag: d.notiId, // cùng notiId -> không hiện chồng
          data: d, // để SW mở đúng trang chi tiết khi bấm vào
        }).then((status) => {
          // "shown-sw" | "shown-window" = đã hiện. Còn lại là KHÔNG hiện được gì -> phải biết
          // lý do, nếu không thì noti chat im lặng tuyệt đối vì đã bỏ popup antd.
          if (status !== "shown-sw" && status !== "shown-window") {
            console.warn("[NOTI] khong hien duoc OS notification:", status, { title, body });
          }
        });
        return;
      }

      // Noti hệ thống ERP: giữ nguyên như cũ - chỉ popup trong app, không bung ra ngoài desktop.
      notification.info({
        message: title,
        description: body,
        duration: 10,
        icon: <Avatar src={imageUrl ? imageUrl : <MailOutlined />} />,
      });
    });
    return unsubscribe;
  }, []);

  return (
    <div className="App">
      <Provider store={store}>
        <BrowserRouter history={history}>
          {CHAT_ENABLED && <ChatLauncher />}
          <ThemeSwitcherProvider
            themeMap={themes}
            defaultTheme={THEME_CONFIG.currentTheme}
            insertionPoint="styles-insertion-point"
          >
            <Layouts />
          </ThemeSwitcherProvider>
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
